import staffBeatriz from '../assets/images/ONDA_Cons_foto_Ana-Beatriz-Fernandes-Cerbino.png';
import staffKelly from '../assets/images/ONDA_Cons_foto_Kelly-Lissandra-Bruch.png';
import staffLeandro from '../assets/images/ONDA_Cons_foto_Leandro-José-Luz-Riodades-de-Mendonça.png';
import staffMarcos from '../assets/images/ONDA_Cons_foto_Pedro-Marcos-Nunes-Barbosa.png';
import staffSarita from '../assets/images/ONDA_Cons_foto_Sarita-Albagli.png';
import staffVieira from '../assets/images/ONDA_Cons_foto_Sérgio-Vieira-Branco-Júnior.png';
import staffSaas from '../assets/images/ONDA_Cons_foto_liz-saas.png';
import staffLobato from '../assets/images/ONDA_Cons_foto_luisa-lobato.png';
import staffRenataReis from '../assets/images/ONDA_Cons_foto_renata-reis.png';
import staffAmiel from '../assets/images/ONDA_Cons_foto_tel-amiel.png';
import staffArruda from '../assets/images/ONDA_Cons_foto_vanessa-de-arruda.png';
import staffSaldanha from '../assets/images/ONDA_Cons_foto_alexandre-saldanha.png';
import staffChamas from '../assets/images/ONDA_Cons_foto_claudia-chamas.png';
import staffCarboni from '../assets/images/ONDA_Cons_foto_guilherme-carboni.png';
import staffCalabre from '../assets/images/ONDA_Cons_foto_lia-calabre.png';
import staffValente from '../assets/images/ONDA_Cons_foto_Mariana Valente-01.jpeg';
import staffSilveira from '../assets/images/ONDA_Cons_foto_newton-silveira.png';
import staffAufderheide from '../assets/images/ONDA_Cons_foto_Patricia Aufderheide.png';
import staffPorto from '../assets/images/ONDA_Cons_foto_patricia-porto.png';
import staffcastro from '../assets/images/ONDA_Cons_foto_ana-célia-castro.png';
import staffMorato from '../assets/images/ONDA_Cons_foto_Carlos-Morato.png';
import staffMalavota from '../assets/images/ONDA_Cons_foto_Leandro-Malavota.png';
import staffFabricio from '../assets/images/ONDA_Cons_foto_FABRICIO-POLIDO.png';
import staffPaula from '../assets/images/ONDA_Cons_foto_Paula.png';
// import staff from '../assets/images/.png';

const mock = [{
  image: staffcastro,
  name: 'Ana Célia Castro',
  description: 'Doutorado em Ciências Econômicas pela Universidade Estadual de Campinas (1988) e pós-doutorado (Universidade da Califórnia, Berkeley, 1999/2000). Professora Titular da Universidade Federal do Rio de Janeiro.',
  social: {
    linkedin: 'https://www.linkedin.com/in/ana-castro-anacelia-castro-36223863/',
    curriculum: 'http://lattes.cnpq.br/4821494129200374',
  }
}, {
  image: staffSaldanha,
  name: 'Alexandre Saldanha',
  description: 'Doutor em Direito pela Universidade Federal de Pernambuco. Mestre em Direito pela Universidade Federal de Pernambuco. Especialista em Direito Processual Civil pela Universidade Federal de Pernambuco. Professor da Universidade de Pernambuco (UPE) e da Universidade Católica de Pernambuco.',
  social: {
    linkedin: '',
    curriculum: 'http://lattes.cnpq.br/6185488373061972',
  }
 }, {
  image: staffBeatriz,
  name: 'Beatriz Cerbino',
  description: 'Doutora em História pela Universidade Federal Fluminense (2007). Obteve bolsa para doutorado sanduíche na NYU, na Tisch School, como visiting schoolar. Atualmente é professora adjunta da Universidade Federal Fluminense.',
  social: {
    linkedin: 'https://www.linkedin.com/in/beatriz-cerbino-124a04a8/',
    curriculum: 'http://lattes.cnpq.br/8061466348939902',
  }
}, {
  image: staffMorato,
  name: 'Carlos Morato',
  description: 'Doutor em Direito Civil pela Faculdade de Direito da Universidade de São Paulo (USP). Advogado e Professor Universitário pela Faculdade de Direito da Universidade de São Paulo - USP (Largo de São Francisco).',
  social: {
    linkedin: 'https://www.linkedin.com/in/antonio-carlos-morato-46a6966a/',
    curriculum: 'http://lattes.cnpq.br/0543441763339721',
  }
}, {
  image: staffChamas,
  name: 'Claudia Chamas',
  description: 'Doutora em Engenharia de Produção pela UFRJ. Professora do quadro permanente do Programa de Mestrado e Doutorado em Políticas Públicas, Estratégias e Desenvolvimento, do Instituto de Economia da Universidade Federal do Rio de Janeiro (IE/UFRJ).',
  social: {
    linkedin: 'https://www.linkedin.com/in/chamas/',
    curriculum: 'http://lattes.cnpq.br/4287647692016596',
  }
}, 
// {
//   image: staff01,
//   name: 'Graziela Zucoloto',
//   description: 'Doutora em Economia da Industria e da Tecnologia pela Universidade Federal do Rio de Janeiro (2009). Pesquisadora no Institute of Applied Economic ',
//   social: {
//     linkedin: 'https://www.linkedin.com/in/graziela-zucoloto-85b2a31b/',
//     curriculum: 'http://lattes.cnpq.br/9863017740356667',
//   }
// }, 
{
  image: staffFabricio,
  name: 'Fabrício Polido',
  description: 'Doutor em Direito Internacional pela Universidade de São Paulo. Professor Associado de Direito Internacional, Direito Comparado e Novas Tecnologias da Faculdade de Direito da UFMG.',
  social: {
    linkedin: 'https://www.linkedin.com/in/fabr%C3%ADcio-bertini-pasquot-polido-b9432425/',
    curriculum: 'http://lattes.cnpq.br/0945463330398836',
  }
}, 
{
  image: staffCarboni,
  name: 'Guilherme Carboni',
  description: 'Doutor e Mestre em Direito Civil pela Faculdade de Direito da USP. Professor do Programa de Pós-graduação Lato Sensu da Direito SP (FGVLaw). Diretor-fundador do Instituto de Economias Sustentáveis e Direito (IESD).',
  social: {
    linkedin: 'https://www.linkedin.com/in/guilherme-carboni-72589a110/',
    curriculum: 'http://lattes.cnpq.br/0292206430922991',
  }
}, 
// {
//   image: staff01,
//   name: 'João Quintais',
//   description: 'Professor assistente na University of Amsterdam.',
//   social: {
//     linkedin: 'https://www.linkedin.com/in/jo%C3%A3o-pedro-quintais-8947211a/',
//     curriculum: '',
//   }
// }, 
{
  image: staffKelly,
  name: 'Kelly Bruch',
  description: 'Doutora pela UFRGS. Professora de Direito na UFRGS.',
  social: {
    linkedin: 'https://www.linkedin.com/in/kelly-bruch-a0960712/',
    curriculum: 'http://lattes.cnpq.br/2285127061716886',
  }
}, {
  image: staffLeandro,
  name: 'Leandro Mendonça',
  description: 'Doutor em Ciência da Comunicação pela Universidade de São Paulo (2007). Professor do Departamento de Arte e Estudos Culturais (PURO-UFF), do Programa de Pós-Graduação em Ciência das Artes (PPGCA-UFF) e do Programa de Pós-Graduação em Políticas Públicas, Estratégias e Desenvolvimento (PPED-UFRJ).',
  social: {
    linkedin: '',
    curriculum: 'http://lattes.cnpq.br/5441010369253243',
  }
}, {
  image: staffMalavota,
  name: 'Leandro Malavota',
  description: 'Doutor em História pela Universidade Federal Fluminense (UFF). Analista do Instituto Brasileiro de Geografia e Estatística (IBGE), Professor da Academia da Propriedade Intelectual, do Instituto Nacional da Propriedade Industrial (INPI).',
  social: {
    linkedin: 'https://www.linkedin.com/in/leandro-malavota-b10b8334/',
    curriculum: 'http://lattes.cnpq.br/7121023413333122',
  }
},
{
  image: staffCalabre,
  name: 'Lia Calabre',
  description: 'Doutora em história pela UFF. Professora do PPGMA/FRCB, do PPGCult/UFF e colaboradora da Maestria en Politicas Culturales da Universidad de la República -CURE (Uruguai).',
  social: {
    linkedin: 'https://www.linkedin.com/in/lia-calabre-casa-rui-648a566',
    curriculum: 'http://lattes.cnpq.br/7913911848859139',
  }
},{
  image: staffSaas,
  name: 'Liz Sass',
  description: 'Doutora em Direito pela Universidade Federal de Santa Catarina - UFSC (2016). Professora adjunta no Departamento de Direito e no Programa de Pós Graduação em Direito da Universidade Federal de Santa Catarina - UFSC.',
  social: {
    linkedin: 'https://www.linkedin.com/in/liz-beatriz-sass-b2973888/',
    curriculum: 'http://lattes.cnpq.br/9777462886016830',
  }
},
{
  image: staffLobato,
  name: 'Luisa Lobato',
  description: 'Doutora em Relações Internacionais pela Pontifícia Universidade Católica do Rio de Janeiro (2022). Professora do quadro complementar da Pontifícia Universidade Católica do Rio de Janeiro e coordenadora do Laboratório de Humanidades Digitais da PUC-Rio.',
  social: {
    linkedin: '',
    curriculum: 'http://lattes.cnpq.br/1926156194903187',
  }
}, {
  image: staffValente,
  name: 'Mariana Valente',
  description: 'Doutora em Sociologia Jurídica pela Faculdade de Direito da Universidade de São Paulo (FDUSP). Professora assistente na Universität Saint Gallen, diretora associada no InternetLab.',
  social: {
    linkedin: 'https://www.linkedin.com/in/mariana-valente-44907652/',
    curriculum: 'http://lattes.cnpq.br/1349409405306350',
  }
},
{
  image: staffSilveira,
  name: 'Newton Silveira',
  description: ' (In memoriam) \nDoutor em Direito Comercial. Professor Doutor de Pós Graduação em Propriedade Intelectual na Faculdade de Direito da USP.',
  social: {
    linkedin: 'https://www.linkedin.com/in/newton-silveira-66344570/',
    curriculum: 'http://lattes.cnpq.br/4627564277032540',
  }
},
{
  image: staffAufderheide,
  name: 'Patrícia Aufderheide',
  description: 'Trabalha em mídia, política e interesse público. Pesquisa documentários - ética, história, tendências, estilos; política de direitos autorais, particularmente a doutrina do uso justo e sua relação com a prática criativa; práticas de cultura digital; e política de comunicação e Internet.',
  social: {
    linkedin: 'https://www.linkedin.com/in/patricia-aufderheide-a636581/',
    curriculum: '',
  }
},
// {
//   image: staffDiaz,
//   name: 'Patricia Díaz Charquero',
//   description: 'Atua em linhas de pesquisa relacionadas a: propriedade intelectual e interesse público, privacidade e liberdade de expressão na Internet, Dados Abertos e Ciência Aberta para promover o acesso ao conhecimento na era digital.',
//   social: {
//     linkedin: 'https://www.linkedin.com/in/drapatriciadiaz/',
//     curriculum: '',
//   }
// },
{
  image: staffPorto,
  name: 'Patrícia Porto',
  description: 'Doutora pela UFRJ em Políticas Públicas, Estratégias e Desenvolvimento. Advogada e conferencista em Propriedade Intelectual. Professora pelo INPI Academy e PUC/RJ.',
  social: {
    linkedin: 'https://www.linkedin.com/in/patricia-porto-38855911/',
    curriculum: 'http://lattes.cnpq.br/5550265869708930',
  }
},
{
  image: staffPaula,
  name: 'Paula Westenberger',
  description: 'Professora de Propriedade Intelectual na Brunel University London. PhD e LLM em Propriedade Intelectual pela Queen Mary University of London.',
  social: {
    linkedin: 'https://www.linkedin.com/in/paula-westenberger-0059a748',
    curriculum: '',
  }
}, 
{
  image: staffMarcos,
  name: 'Pedro Marcos Nunes Barbosa',
  description: 'Doutor em Direito Comercial pela Universidade de São Paulo (2016)Professor de Direito Civil, Direito Comercial e Direito da Propriedade Intelectual nos cursos de graduação e pós-graduação em Direito da PUC-Rio.',
  social: {
    linkedin: 'https://www.linkedin.com/in/pedro-marcos-nunes-barbosa-46176b17a/',
    curriculum: 'http://lattes.cnpq.br/9042632102791693',
  }
}, {
  image: staffSarita,
  name: 'Sarita Albagli',
  description: 'Doutora em Geografia (UFRJ). Professora no Programa de Pós-Graduação em Ciência da Informação IBICT-UFRJ.',
  social: {
    linkedin: 'https://www.linkedin.com/in/sarita-albagli/',
    curriculum: 'http://lattes.cnpq.br/8946328562221916',
  }
}, {
  image: staffVieira,
  name: 'Sergio Branco',
  description: 'Doutor e Mestre em Direito Civil pela Universidade do Estado do Rio de Janeiro UERJ. Diretor do Instituto de Tecnologia e Sociedade do Rio de Janeiro. Professor da Faculdade de Ciências Sociais Aplicadas Ibmec.',
  social: {
    linkedin: 'https://www.linkedin.com/in/s%C3%A9rgio-branco-8b57a517/',
    curriculum: ' http://lattes.cnpq.br/1052318679517461',
  }
}, {
  image: staffRenataReis,
  name: 'Renata Reis',
  description: 'Doutora em Políticas Públicas, Estratégias e Desenvolvimento na UFRJ. Diretora-Geral Adjunta na Médecins Sans Frontières (MSF).',
  social: {
    linkedin: 'https://www.linkedin.com/in/renata-reis-1b4a5210/',
    curriculum: 'http://lattes.cnpq.br/9544296839887529',
  }
}, {
  image: staffAmiel,
  name: 'Tel Amiel',
  description: 'Doutor em Instrucional Technology. Professor do Departamento de Métodos e Técnicas da Faculdade de Educação da Universidade de Brasília.',
  social: {
    linkedin: '',
    curriculum: 'http://lattes.cnpq.br/0246540741711761',
  }
}, {
  image: staffArruda,
  name: 'Vanessa de Arruda Jorge',
  description: 'Doutora em Ciência da Informação pelo convênio IBICT/UFRJ. Coordenadora de Informação e Comunicação da Vice-presidência de Educação, Informação e Comunicação (VPEIC) da Fiocruz.',
  social: {
    linkedin: 'https://www.linkedin.com/in/vanessa-jorge-26b56636/',
    curriculum: 'http://lattes.cnpq.br/0218139692140149',
  }
}
];

export default mock;